import Inputmask from 'inputmask';

Inputmask.extendAliases({
  card: {
    mask: '9999 9999 9999 9999',
    inputmode: 'tel',
    placeholder: 'X',
  },
  phone: {
    mask: '+7 (999) 999-99-99',
    inputmode: 'tel',
    onBeforeMask(value) {
      return value.replace(/^(\+7|8)/, '');
    },
    onUnMask(maskedValue) {
      return maskedValue.replace(/(\(|\)|\s|-)/g, '');
    },
  },
  date: {
    mask: '99.99.9999',
    placeholder: '_',
    onUnMask(maskedValue) {
      return maskedValue;
    },
  },
});

function InputMask() {
  const self = this;

  self.init = function init(element) {
    const $el = $(element);

    if ($el.data('app-module-initialized-inputmask')) return; // Prevent double init

    const mask = $el.data('mask');
    const alias = $el.data('mask-alias');
    const placeholder = $el.data('mask-placeholder');

    const config = {
      placeholder,
      clearIncomplete: false,
      showMaskOnHover: false,
      greedy: false,
      autoUnmask: true,
      mask,
      alias,
    };

    Inputmask(config).mask(element);

    $el.data('app-module-initialized-inputmask', true);
  };

  self.initAll = function initAll() {
    $('.js-input-mask').each(function init() {
      self.init(this);
    });
  };
}

export default new InputMask();
